import { render } from "./ExternalTranslationVariants.vue?vue&type=template&id=14a4451c&scoped=true&ts=true"
import script from "./ExternalTranslationVariants.vue?vue&type=script&lang=ts"
export * from "./ExternalTranslationVariants.vue?vue&type=script&lang=ts"

import "./ExternalTranslationVariants.vue?vue&type=style&index=0&id=14a4451c&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14a4451c"]])

export default __exports__